import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_ATTACHABLE_AWS_INTEGRATIONS_FOR_SCAN } from "./gql";

const useAttachableAwsIntegrations = (spaceId: string | undefined) => {
  const { data, error, loading } = useQuery(GET_ATTACHABLE_AWS_INTEGRATIONS_FOR_SCAN, {
    variables: { id: spaceId ?? "" },
    skip: !spaceId,
  });

  // A scan can only use an integration that generates its credentials in the worker
  // (scanCreate/scanUpdate reject anything else), so legacy/non-worker-side ones are dropped.
  const integrations = useMemo(
    () =>
      (data?.attachableAwsIntegrationsInSpace ?? []).filter(
        (integration) => !integration.legacy && integration.generateCredentialsInWorker
      ),
    [data?.attachableAwsIntegrationsInSpace]
  );

  return {
    integrations,
    error,
    loading,
  };
};

export default useAttachableAwsIntegrations;
